import { compareShellLots } from '@features/buyer-line-items-pagination/utils/compare-shell-lots';
import type { ListedLot } from '@features/buyer-line-items-pagination/types/listed-lot';

/**
 * The event shell's lots, sorted, each carrying the event's `adder_column_limit`, which the table reads from
 * the lot and the lot list does not return.
 */
export const buildShellLots = (lots: ListedLot[], adderColumnLimit?: number): ListedLot[] => (
  lots.map(lot => ({ ...lot, adder_column_limit: adderColumnLimit })).sort(compareShellLots)
);
